export default async ({ app, $route }) => {
  if (typeof window.$OP === 'undefined') {
    // users not authenticated in OnePlace
    console.log('No OnePlace found')
    await app.$oneplaceHelper.goLogin()
    // workaround for to wait window.location.href in app.$oneplaceHelper.goLogin. window.location.href will interrupt the promise
    return new Promise((resolve) => {
      setTimeout(() => resolve(), 1000 * 10)
    })
  }
}
